import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPropertyBasicModel, HxOrganizationService, OrganizationModel } from 'hx-services';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { NotificationService } from '@adm-web-app/services/notification.service';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NgIf } from '@angular/common';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTagComponent } from 'ng-zorro-antd/tag';

@Component({
    selector: 'hc-organization-property-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzSpinComponent, TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, NzInputDirective, NzRadioGroupComponent, NzRadioComponent, NgIf, NzAlertComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NzTagComponent, TranslocoPipe]
})
export class OrganizationPropertyEditComponent implements OnInit, OnDestroy {
  prop?: AppPropertyBasicModel;
  isEdit = false;
  isCreate = false;
  form = new FormGroup({
    enabled: new FormControl<boolean | null>(null, [Validators.required]),
    key: new FormControl<string | null>(null, [Validators.required]),
    value: new FormControl<string | null>(null, [Validators.required]),
  });
  isSaving = false;
  org!: OrganizationModel;
  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private orgService: HxOrganizationService,
    private nt: NotificationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.org = routeData['organization'] as OrganizationModel;
    this.prop = routeData['property'] as AppPropertyBasicModel;
    if (this.prop) {
      this.isEdit = true;
    } else {
      this.isCreate = true;
    }
    if (this.isEdit) {
      this.form.controls.key.disable();
    }

    this.form.patchValue({
      enabled: this.prop.enabled,
      key: this.prop.key,
      value: this.prop.value ? JSON.stringify(this.prop.value) : ''
    });
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.getRawValue();
      if (formModel.enabled === null
        || formModel.enabled === undefined
        || !formModel.key
        || !formModel.value
      ) {
        throw new Error('form.required.fields');
      }
      this.isSaving = true;
      try {
        await this.orgService.saveProperty(this.org.id, {
          enabled: formModel.enabled,
          key: formModel.key,
          value: JSON.parse(formModel.value)
        });
        this.form.markAsPristine();
        this.nt.success('organizations.property.title', 'nt.dataSaved');
        if (this.isCreate) {
          await this.router.navigate([`/organizations/${this.org.id}/properties/${formModel.key}/edit`]);
        }
      } finally {
        this.isSaving = false;
      }
    } else {
      console.log('not valid form');
    }
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
